import { useState, useRef, useEffect } from 'react'
import { FiChevronDown } from 'react-icons/fi'
import OutsideClickHandler from 'react-outside-click-handler'

const TemplateDropdown = ({ options, selectedValue, onSelect, placeholder = 'Select', labelKey = 'label', valueKey = 'value' }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [search, setSearch] = useState('')
  const inputRef = useRef(null)

  const selectedLabel =
    selectedValue !== null && selectedValue !== undefined && selectedValue !== ''
      ? options.find((o) => o[valueKey] === selectedValue)?.[labelKey] || placeholder
      : placeholder

  const filtered = search
    ? options.filter((o) => o[labelKey]?.toLowerCase().includes(search.toLowerCase()))
    : options

  useEffect(() => {
    if (isOpen && inputRef.current) inputRef.current.focus()
    if (!isOpen) setSearch('')
  }, [isOpen])

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative w-full">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 cursor-pointer"
        >
          <span className="font-OpenSansRegular text-[12px]">{selectedLabel}</span>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
            <div className="w-full h-[30px] border-solid border-b-[1px] flex items-center justify-center px-[15px]">
              <input
                ref={inputRef}
                value={search}
                type="text"
                onChange={(e) => setSearch(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Search..."
              />
            </div>
            {filtered.map((opt) => (
              <li
                key={opt[valueKey]}
                onClick={() => {
                  onSelect(opt[valueKey])
                  setIsOpen(false)
                }}
                className="px-4 py-2 cursor-pointer hover:bg-gray-200 font-OpenSansRegular text-[12px]"
              >
                <span className="font-OpenSansRegular text-[12px]">{opt[labelKey]}</span>
              </li>
            ))}
            {filtered.length === 0 && (
              <li className="px-4 py-2 text-[11px] font-OpenSansRegular text-subTitleColor">
                No results found
              </li>
            )}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  )
}

export default TemplateDropdown
